<h2 mat-dialog-title>Typ dokumentu</h2>

<mat-dialog-content>
	<mat-form-field class="w-100">
		<mat-label>Typ</mat-label>
		<mat-select [formControl]="kindControl">
			@for (option of options; track option.value) {
				<mat-option [value]="option.value">{{ option.label }}</mat-option>
			}
		</mat-select>
	</mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button (click)="cancel()">Anuluj</button>
	<button mat-raised-button color="primary" (click)="confirm()">Dalej</button>
</mat-dialog-actions>
